import Vue from "vue";
import InPageNavigation from "./in-page-navigation";

document.addEventListener("DOMContentLoaded", () => {
  const mount = document.querySelector('[data-in-page-navigation]');
  const anchorIds = [...document.querySelectorAll('[data-anchor]')].map(el => el.id);
  const anchorTitles = [...document.querySelectorAll('[data-anchor]')].map(el => el.getAttribute('data-anchor-title'));

  if (mount) {
    new Vue({
      el: mount,
      components: { InPageNavigation },
      data: {
        anchorIds: anchorIds,
        anchorTitles: anchorTitles,
      },
      template:
        `
          <InPageNavigation :anchorIds=anchorIds :anchorTitles=anchorTitles></InPageNavigation>
        `
    });
  }
});
